import React, { Component } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import Dropzone from 'react-dropzone';
import imageToBase64 from 'src/components/util/imagetobase64';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { getDate, getMonth, getYear } from 'src/utils/common';
import { convertChannelIdToName } from 'src/utils/convert-channel';
import Cookies from 'js-cookie'
// const IMG_SERVER = process.env.REACT_APP_IMG;
const IMG_SERVER = process.env.REACT_APP_CDN;
const isGif = str => RegExp(/\.gif$/i).test(str);

const getDimensions = (url) => {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.style.position = "absolute";
    img.style.left = -9999;             // Image width must not exceed 9999 pixels
    img.style.visibility = "hidden";    // Maybe you can remove this
    img.style.minWidth = "100%";
    img.src = url;
    img.onload = () => {
      var height = img.height;
      var width = img.width;
      resolve({
        width, height
      });
    }
    img.onerror = (err) => {
      reject(err);
    }
  })
}
export default class Uploader extends Component {
  constructor(props) {
    super(props);
    this.tmp_id = props.tmp_id;
    this.fy = getYear(props.post ? props.post.createdAt : null);
    this.fm = getMonth(props.post ? props.post.createdAt : null);
    this.fdate = getDate(props.post ? props.post.createdAt : null);
    this.jwt = Cookies.get("jwt");
    this.user_id = Cookies.get("user_id");
    this.editor_type = props.post ? (props.post.editor_type || 'normal') : 'normal';
    let requireWidth;
    let requireHeight;
    let optimizedWidth;
    let optimizedHeight;
    if(props.noRequireSize){
      requireWidth = 0;
      requireHeight = 0;
      optimizedWidth = 0;
      optimizedHeight = 0;
    }
    else{
      requireWidth = (props.type == 'horizontal') ? 660 : 414;
      requireHeight =  (props.type == 'horizontal') ? 414 : 660;
      optimizedWidth = (props.type == 'horizontal') ? 1200 : 0;
      optimizedHeight = (props.type == 'horizontal') ? 750 : 0;
    }

    const errorWidthText = 'Chiều ngang hình ảnh phải lớn hơn ' + requireWidth + 'px';
    const errorheightText = 'Chiều dài hình ảnh phải lớn hơn ' + requireHeight + 'px';
    const errorText = 'Hình ảnh nhỏ hơn kích thước quy định';

    const initSrcCrop = props.initSrcCrop ? props.initSrcCrop : null ;

    this.state = {
      src: initSrcCrop,
      crop: props.crop,
      files: [],
      errorFile: '',
      editing: props.url ? false : true,
      finish: false,
      finalSrc: null,
      croppedBlob: null,
      fileName: '',
      no_crop: props.no_crop || false,
      dragagain: props.dragagain || false,
      urlfromProp: props.url,
      resetimage: false,
      requireWidth,
      requireHeight,
      optimizedWidth,
      optimizedHeight,
      errorWidthText,
      errorheightText,
      errorText,
      channel: props.channel,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(!this.props.noRequireSize){
      const { editor_type: nextEditorType, crop : nextCrop, type: nextType, initSrcCrop: nextInitSrcCrop } = nextProps;
      const { editor_type, crop, type, initSrcCrop } = this.props;
      // const cropPodcast = {
      //   requireWidth : (nextType == 'horizontal') ? 660 : 660,
      //   requireHeight :  (nextType == 'horizontal') ? 371 : 660,
      //   optimizedWidth : (nextType == 'horizontal') ? 1200 : 0,
      //   optimizedHeight : (nextType == 'horizontal') ? 675 : 0,
      // }
      // const cropNormal = {
      //   requireWidth : (nextType == 'horizontal') ? 660 : 414,
      //   requireHeight :  (nextType == 'horizontal') ? 414 : 660,
      //   optimizedWidth : (nextType == 'horizontal') ? 1200 : 0,
      //   optimizedHeight : (nextType == 'horizontal') ? 750 : 0,
      // }
      switch(nextEditorType){
        case 'podcast':
          if(nextCrop.aspect != crop.aspect){
            this.setState({
              requireWidth : (nextType == 'horizontal') ? 660 : 660,
              requireHeight :  (nextType == 'horizontal') ? 371 : 660,
              optimizedWidth : (nextType == 'horizontal') ? 1200 : 0,
              optimizedHeight : (nextType == 'horizontal') ? 675 : 0,
              crop: nextCrop,
            });
          }
          break;
        case 'video':
          if(nextCrop.aspect != crop.aspect){
            this.setState({
              requireWidth: (nextType == 'horizontal') ? 660 : 371,
              requireHeight:  (nextType == 'horizontal') ? 371 : 660,
              optimizedWidth: (nextType == 'horizontal') ? 1200 : 0,
              optimizedHeight:(nextType == 'horizontal') ? 750 : 0,
              crop: nextCrop,
            });
          }
          break;
        case 'short':
          if(nextCrop.aspect != crop.aspect){
            this.setState({
              requireWidth: (nextType == 'horizontal') ? 660 : 371,
              requireHeight:  (nextType == 'horizontal') ? 371 : 660,
              optimizedWidth: (nextType == 'horizontal') ? 1200 : 0,
              optimizedHeight:(nextType == 'horizontal') ? 750 : 0,
              crop: nextCrop,
            });
          }
          break;
        default:
          if(nextCrop.aspect != crop.aspect){
            this.setState({
              requireWidth: (nextType == 'horizontal') ? 660 : 414,
              requireHeight:  (nextType == 'horizontal') ? 414 : 660,
              optimizedWidth: (nextType == 'horizontal') ? 1200 : 0,
              optimizedHeight:(nextType == 'horizontal') ? 750 : 0,
              crop: nextCrop,
            });
          }
      }
      if(!this.state.src && nextInitSrcCrop && nextInitSrcCrop != initSrcCrop){
        this.setState({
          src: nextInitSrcCrop
        })
      }
    }
    // set state channel uploader khi post content thay đổi
    this.setState({channel: nextProps.channel});
  }

  confirmAction = (message) => {
    return new Promise((resolve, reject) => {
      const options = {
        childrenElement: () => <div />,
        customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
            <h1>Xác nhận thao tác?</h1>
            <div className="mr-4 mb-4 ml-4">{message}</div>
            <div className="box">
              <div className="bg-d9534f" onClick={() => {
                resolve(false);onClose();
              }}>Không, cần xem lại
              </div>
              <div
                className="bg-c7c6c5"
                onClick={() => {
                  resolve(true);onClose();
                }}
              > Có, tiếp tục
              </div>
            </div>
          </div>
        ),
        closeOnEscape: true,
        closeOnClickOutside: true,
        willUnmount: () => { },
        onClickOutside: () => { },
        onKeypressEscape: () => { }
      };
    
      confirmAlert(options);
    });
  }

  checkImageValidity = ({width, height}) => {
    const scope = this;
    const { 
      requireWidth, 
      requireHeight, 
      optimizedWidth,
      optimizedHeight,
      errorText, 
      errorWidthText, 
      errorheightText,
      crop,
      no_crop
    } = this.state;
    console.log(scope.props.noRequireSize);
    const meetRequirement = (width >= requireWidth && height >= requireHeight);
    const meetOptimization = (width >= optimizedWidth && height >= optimizedHeight);
    const needOptimize = scope.props.noRequireSize ? false : (optimizedWidth && optimizedHeight);

    const imageAspect = (width/height);
    const targetAspect = no_crop ? (requireHeight/requireWidth) : crop.aspect;
    const needCrop = imageAspect.toFixed(2) !== targetAspect.toFixed(2);
    // console.log(needCrop, imageAspect.toFixed(2), targetAspect.toFixed(2))
    if(!needCrop) {
      //this.setState({no_crop: true});
      this.setState({no_crop: false}); //force crop
    }

    if(needOptimize) {
      if(meetOptimization) return Promise.resolve(true);
      if(meetRequirement) {
        return this.confirmAction(`Ảnh bạn chọn có kích thước ${width}x${height}. Sử dụng ảnh nhỏ hơn ${optimizedWidth}x${optimizedHeight} sẽ không được tối ưu! Bạn có muốn tiếp tục không?`);
      }
    } else {
      if(meetRequirement) return Promise.resolve(true);
    }

    if (width < requireWidth) {
      this.setState({ errorFile: errorWidthText });
    } else if (height < requireHeight) {
      this.setState({ errorFile: errorheightText });
    }
    return Promise.resolve(false);

  }

  onDrop = (files) => {

    const { requireWidth, requireHeight, errorText, errorWidthText, errorheightText } = this.state;
    const scope = this;
    scope.setState({ errorFile: '' });

    if (files.length > 0) {
      const reader = new FileReader();
      let fileDroped = files[0];
      if(isGif(fileDroped.name) && fileDroped.type === 'image/gif'){
        this.setState({ fileName: fileDroped.name, no_crop: true });
      } else {
        this.setState({ fileName: fileDroped.name });
      }
      reader.readAsDataURL(fileDroped);

      reader.addEventListener('load', () => {
        let img = new Image();
        img.crossOrigin = '*';
        img.src = reader.result;

        if (this.state.no_crop) {
          img.onload = async function () {
            const rawBlob = scope.b64toBlob(reader.result, fileDroped.type);
            let blobURL = URL.createObjectURL(rawBlob);
            if (!scope.props.noRequireSize) {
              const height = this.height;
              const width = this.width;

              const isValid = await scope.checkImageValidity({width, height});
              if(!isValid) {
                return;
              }

            }
            scope.setState({
              editing: false, finish: true, finalSrc: blobURL, resetimage: false
            }, () => {
              if (scope.props.handleImageCrop) {
                scope.props.handleImageCrop({ blob: blobURL, rawBlob, type: scope.props.type, filename: fileDroped.name });
              }
            })

          }
          
        } else {
          img.onload = function () {

            const height = this.height;
            const width = this.width;
            if (scope.props.noRequireSize) {
              scope.setState({ src: reader.result, errorFile: '' });
              scope.setState({ finish: false });
            } else {
              scope.checkImageValidity({width, height}).then(isValid => {
                if(isValid) {
                  scope.setState({ src: reader.result, errorFile: '' });
                  scope.setState({ finish: false });
                }
              })
            }
          };

        }
      });
    } else {
      this.setState({ errorFile: 'Image only' })
    }
  }

  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    b64Data = _.split(b64Data, ';base64,');
    const byteCharacters = atob(b64Data[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {

      const reader = new FileReader();
      reader.addEventListener('load', () =>
        this.setState({ src: reader.result, finish: true, editing: false })
      );
      reader.readAsDataURL(e.target.files[0]);
    }

  };


  choseImageCrop = () => {
    if (this.props.handleImageCrop) {
      this.props.handleImageCrop({ blob: this.state.croppedImageUrl, rawBlob: this.state.croppedBlob, type: this.props.type, filename: this.state.fileName });
    }
    this.setState({ finalSrc: this.state.croppedImageUrl, finish: true });
  }

  onImageLoaded = image => {
    image.crossOrigin = 'Anonymous';
    this.imageRef = image;
    const width = image.width >= image.height ? (image.height / image.width) * 100 : 100;
    const height = image.height >= image.width ? (image.width / image.height) * 100 : 100;
    const x = width === 100 ? 0 : (100 - width) / 2;
    const y = height === 100 ? 0 : (100 - height) / 2;

    this.setState({
      crop: {
        aspect: this.state.crop.aspect,
        width: image.width,
      }
    }
    );


    this.setState({ finish: false });

    return false; // Return false if you set crop state in here.
  };


  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    let { dragagain } = this.state;
    this.setState({ crop, editing: false });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {

      const { url, blob } = await this.getCroppedImg(
        this.imageRef,
        crop,
        this.props.type + 'file.jpeg'
      );
      this.setState({ croppedImageUrl: url, croppedBlob: blob });
    }
  }

  getCroppedImg(image, crop, fileName) {

    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    var originWidth = crop.width * scaleX;
    var originHeight = crop.height * scaleY;

    // Chỉ scale lên tối thiểu 1200px nếu là hình ngang, không scale nếu là gif
    let targetWidth, targetHeight;
    if (isGif(fileName)) {
      // Nếu là gif thì giữ nguyên kích thước gốc
      targetWidth = originWidth;
      targetHeight = originHeight;
    } else if (originWidth > originHeight && originWidth < 1200) {
      targetWidth = 1200;
      targetHeight = Math.round(1200 * (originHeight / originWidth));
    } else {
      // logic cũ
      var maxWidth = crop.maxWidth ? crop.maxWidth : originWidth, 
        maxHeight = (crop.maxWidth && crop.aspect) ? crop.maxWidth / (crop.aspect) : originWidth / (crop.aspect);
      targetWidth = originWidth;
      targetHeight = originHeight;
      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
    }
    // set canvas size
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = 'high';
    let imageWidth = crop.width * scaleX;
    let imageHeight = crop.height * scaleY;
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      imageWidth,
      imageHeight,
      0,
      0,
      targetWidth,
      targetHeight
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        blob => {
          if (!blob) {
            // console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          window.URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = window.URL.createObjectURL(blob);
          resolve({ url: this.fileUrl, blob });
        },
        "image/jpeg",
        1
      );
    });
  }


  openFinder = () => {
    const { requireWidth, requireHeight, channel } = this.state;

    if (!this.props.notUseCKFinder) {
      CKFinder.modal({
        chooseFiles: true,
        chooseFilesOnDblClick: true,
        selectMultiple: false,
        width: 800,
        height: 600,
        connectorInfo: `type=Images&responseType=json&currentFolder=/&id=${this.tmp_id}&editorType=${this.editor_type}&fy=${this.fy}&fm=${this.fm}&fd=${this.fdate}&jwt=${this.jwt}&user_id=${this.user_id}&channel=${convertChannelIdToName(channel, this.props.channels)}`,
        onInit: (finder) => {
          finder.on('files:choose', (evt) => {
            const file = evt.data.files.first();
            let url = file.getUrl();
            this.imageagain();

            getDimensions(url)
            .then(this.checkImageValidity)
            .then(isValid => {
              if(isValid) {
                if (this.state.no_crop || isGif(file.attributes.name) || file.attributes.type === 'image/gif') {
                  this.setState({
                    editing: false, finish: true, finalSrc: url, resetimage: false, errorFile: ''
                  }, () => {
                    if(this.state.no_crop || isGif(file.attributes.name) || file.attributes.type === 'image/gif') {
                      this.props.noneedcrop({
                        'url': url,
                        'type': this.props.type
                      });
                    }
                  })
                } else {
                  imageToBase64(url, {
                    method  : 'GET', 
                    headers : {
                      "User-Agent"   : navigator.userAgent
                    }
                  }) // you can also to use url
                    .then(
                      (response) => {
                        this.setState({
                          src: response, fileName: file.attributes.name.toLowerCase(),
                          editing: true, finish: false, resetimage: true
                        }, () => {
                        });
    
                        // this.setState({editing: true, finish: false, src: null, resetimage: true})
                      }
                    )
                    .catch(
                      (error) => {
                        console.log(error); //Exepection error....
                      }
                    )
                }
              }
            })

          });
          // finder.on( 'file:choose:resizedImage', function( evt ) {
          //   var output = document.getElementById( elementId );
          //   output.value = evt.data.resizedUrl;
          // } );
        }
      });
    }
  }

  startDownload(urlImg) {
    let imageURL = urlImg;

    let downloadedImg = new Image;
    downloadedImg.crossOrigin = "Anonymous";
    downloadedImg.addEventListener("load", this.imageReceived, false);
    downloadedImg.src = imageURL;
    return downloadedImg;
  }
  imageReceived() {
    let canvas = document.createElement("canvas");
    let context = canvas.getContext("2d");

    canvas.width = downloadedImg.width;
    canvas.height = downloadedImg.height;

    context.drawImage(downloadedImg, 0, 0);
    imageBox.appendChild(canvas);

    try {
      localStorage.setItem("saved-image-example", canvas.toDataURL("image/jpeg"));
    }
    catch (err) {
      console.log("Error: " + err);
    }
  }
  imageagain = () => {
    this.setState({ editing: true, finish: false, src: null, resetimage: true }, () => {
      if (this.props.handleImageCrop) {
        this.props.handleImageCrop({ blob: "", type: this.props.type, filename: "" });
      }
    })
  }

  render() {
    const { crop, croppedImageUrl, src } = this.state;
    let minWidth = this.props.type == 'horizontal' ? 1200 : 750;
    minWidth = this.props.type == 'profile' ? 200 : minWidth;
    const circular = this.props.circular || false;

    // let srcImg = '';
    const srcImg = this.props.url;
    // if (this.props.url && !(this.props.url.includes("http://") || this.props.url.includes("https://"))) {
    //   srcImg = IMG_SERVER + 'uploads/' + this.props.url;
    // } else {
    // }

    return (
      <div className={
        (this.props.type !== 'content_image' ? "container-fluid mt-3 " : "w-100 ") +
        (!this.state.editing ? 'dropzone-editing ' : ' ') +
        (this.props.styleImageBackGround !== '' ? 'mr-2' : '')
      }>

        {
          <div className={"dropzone-" + this.props.type}>
            <Dropzone onDrop={this.onDrop} accept='image/*' >
              {({ getRootProps, getInputProps }) => (
                <section className={this.props.type !== 'content_image' ? "container" : ""} onClick={this.openFinder}>
                  <div {...getRootProps({ className: this.props.type !== 'content_image' ? 'dropzone' : '' })}>
                    {/* get from ckfinder */}
                    {this.props.notUseCKFinder &&
                      <input {...getInputProps()} accept="images/png, images/jpeg, images/jpg" />
                    }
                    {this.state.editing &&
                      (this.props.type === 'content_image'
                        ?
                        <button className={"btn bg-purple btn-block "}>Chọn ảnh nền</button>
                        :
                        <>
                          <p>Kéo thả ảnh vào đây, hoặc nhấn vào để chọn ảnh.</p>
                          <p>Chỉ chọn ảnh định dạng PNG, JPEG, JPG.</p>
                        </>
                      )
                    }
                    {(this.state.errorFile && this.state.errorFile.length > 0) && <p>{this.state.errorFile}</p>}
                    {!this.state.editing &&
                      (this.props.type === 'content_image'
                        ?
                        <button className="btn bg-purple btn-block">Chọn ảnh nền</button>

                        : <p>Chọn ảnh khác <i className="fas fa-images"></i></p>
                      )
                    }
                  </div>
                </section>
              )}

            </Dropzone>
            {(this.state.finish && this.state.dragagain) && <i className="fas fa-times drag-again" onClick={this.imageagain}></i>}
          </div>
        }

        {(this.state.finish) && <img className="final-image" src={this.state.finalSrc} alt="" />}

        {!this.state.finish &&
          <div className="" style={{ position: 'relative' }}>
            {(this.props.url && !src && !this.state.resetimage && srcImg) && <img className={`${this.props.circular ? 'cms-avatar' : ''}`} src={srcImg} />}
            {(src && !this.state.no_crop) && (
              <ReactCrop
                src={src}
                crop={crop}
                ruleOfThirds
                // minWidth={minWidth}
                // minHeight={minWidth * crop.aspect}
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
                imageStyle={{ maxHeight: '1000px' }}
                circularCrop={circular}
                renderSelectionAddon={() => <div style={{
                  position: 'absolute', zIndex: '100',
                  left: 0, fontSize: '30px', color: '#fff ',
                  width: "100%", display: "flex", justifyContent: "space-between"

                }}>
                  <i className="fas fa-check" style={{
                    backgroundColor: "rgba(0,0,0,0.7)", padding: "10px 10px",
                    cursor: 'pointer', color: '#28a745'
                  }} onClick={this.choseImageCrop}></i>
                  <i className="fas fa-times" style={{ backgroundColor: "rgba(0,0,0,0.7)", padding: "10px 10px", cursor: 'pointer', color: '#bd2130', width: '35px', textAlign: 'center' }} onClick={this.imageagain} ></i>
                </div>}
              />
            )}
          </div>
        }
      </div>
    )
  }
};
